"use client";

import Link from "next/link";
import { useState } from "react";
import {usePathname} from 'next/navigation';
import {Menu, X, Phone, BookOpen, Users, Info, Download} from "lucide-react";
import BtnLogin from "@/components/layout/include/BtnLogin";
import BtnInquiryCart from "@/components/layout/include/BtnInquiryCart";
import MenuBar from "@/components/layout/include/MenuBar";
import SearchBox from "@/components/layout/include/SearchBox";
import MenuMobile from "@/components/layout/include/MenuMobile";
import ThemeToggle from "@/components/layout/include/ThemeToggle";
import { Suspense } from "react";
import { NavigationItem } from "@/types/header";

import { useAppContext } from "@/contexts/AppContext";
import Image from "next/image";

const navigation: NavigationItem[] = [
  { name: "دسته‌بندی‌ها", href: "/shop", icon: Menu, action: '1' },
  { name: "مقالات", href: "/blog", icon: BookOpen, action: '0' },
  { name: "انجمن", href: "/forum", icon: Users, action: '0' },
  { name: "درباره ما", href: "/aboutus", icon: Info, action: '0' },
  { name: "تماس با ما", href: "/contact", icon: Phone, action: '0' },
  { name: "کاتالوگ", href: "/catalog", icon: Download, action: '0' },
];

const navigationMobile: NavigationItem[] = [
  { name: "فروشگاه", href: "/shop", icon: Menu, action: '1' },
  { name: "مقالات", href: "/blog", icon: BookOpen, action: '0' },
  { name: "انجمن", href: "/forum", icon: Users, action: '0' },
  { name: "درباره ما", href: "/aboutus", icon: Info, action: '0' },
  { name: "تماس با ما", href: "/contact", icon: Phone, action: '0' },
  { name: "کاتالوگ", href: "/catalog", icon: Download, action: '0' },
];

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { categories } = useAppContext();
  const pathname = usePathname();
  const isHome = pathname === '/';

  return (
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="container no-padd-y">
          <div className="flex items-center justify-between py-4">
            <div className="flex items-center">
              <Link
                  href="/"
                  title={process.env.NEXT_PUBLIC_TITLE}
                  className="flex items-center hover:opacity-80 transition-opacity"
                  prefetch={true}
              >

                <div className="relative text-sm">
                  <Image
                      src={`${process.env.NEXT_PUBLIC_STORAGE_UPLOADS_ASSETS_IMG}/logo/logo.svg`}
                      alt="logo"
                      width={180}
                      height={51}
                      priority
                      className="dark:brightness-0 dark:invert"
                      fetchPriority="high"
                      unoptimized
                  />
                </div>

                {isHome && (
                    <h1 className="sr-only">{process.env.NEXT_PUBLIC_TITLE}</h1>
                )}
              </Link>
            </div>

            <div className={'md:contents flex'}>
              <Suspense fallback={null}>
                <SearchBox />
              </Suspense>
              <div className="flex items-center space-x-4 space-x-reverse">
                <ThemeToggle />
                <BtnInquiryCart />
                <BtnLogin />
                <button
                    type="button"
                    title={'منو'}
                    className="lg:hidden cursor-pointer hover:bg-gray-200 rounded-lg p-2 text-gray-700 hover:text-primary transition-colors"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                  {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                </button>
              </div>
            </div>

          </div>

          <MenuBar categories={categories} navigation={navigation} />
        </div>

        <MenuMobile
            categories={categories || []}
            navigation={navigationMobile}
            mobileMenuOpen={mobileMenuOpen}
            setMobileMenuOpen={setMobileMenuOpen}
        />
      </header>
  );
};

export default Header;
